module.exports = __webpack_public_path__ + "media/public/images/about/services/02-884117e0d7ae7c879e73e5788a0a283c.jpg";